import { useEffect, useState } from 'react';
import { FaFlag, FaSpinner, FaTimes } from 'react-icons/fa';
import { socialService } from '../../services/apiService';

export const REPORT_REASONS = [
  { value: 'spam', label: 'Spam' },
  { value: 'assédio', label: 'Assédio' },
  { value: 'conteúdo-inadequado', label: 'Conteúdo inadequado' },
  { value: 'falsidade', label: 'Falsidade / impersonação' },
  { value: 'outro', label: 'Outro' },
];

export default function ReportModal({
  open,
  targetType,
  targetId,
  title,
  description,
  onClose,
  onSuccess,
}) {
  const [reason, setReason] = useState('conteúdo-inadequado');
  const [details, setDetails] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return undefined;
    setReason('conteúdo-inadequado');
    setDetails('');
    setError('');
    setSubmitting(false);

    const onKeyDown = (event) => {
      if (event.key === 'Escape' && !submitting) onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose, submitting]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!targetId || submitting) return;

    setSubmitting(true);
    setError('');
    try {
      await socialService.createReport({
        targetType,
        targetId,
        reason,
        details: details.trim(),
      });
      onSuccess?.('Denúncia enviada para análise.');
      onClose();
    } catch (err) {
      setError(err.message || 'Não foi possível enviar a denúncia.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="network-modal-backdrop report-modal-backdrop"
      onClick={() => { if (!submitting) onClose(); }}
      role="presentation"
    >
      <form
        className="network-modal report-modal"
        onClick={(event) => event.stopPropagation()}
        onSubmit={handleSubmit}
        aria-labelledby="report-modal-title"
      >
        <header className="network-modal-head">
          <div className="network-modal-titles">
            <p className="network-modal-kicker">
              <FaFlag aria-hidden="true" /> Moderação
            </p>
            <h2 id="report-modal-title">{title}</h2>
            <p className="network-modal-lead">{description}</p>
          </div>
          <button
            type="button"
            className="network-modal-close"
            aria-label="Fechar"
            disabled={submitting}
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </header>

        <div className="network-modal-body report-modal-body">
          <fieldset className="report-reason-list">
            <legend>Motivo</legend>
            {REPORT_REASONS.map((option) => (
              <label key={option.value} className={`report-reason-option${reason === option.value ? ' is-selected' : ''}`}>
                <input
                  type="radio"
                  name="report-reason"
                  value={option.value}
                  checked={reason === option.value}
                  onChange={() => setReason(option.value)}
                  disabled={submitting}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </fieldset>

          <label className="report-details-field">
            <span>Detalhes (opcional)</span>
            <textarea
              value={details}
              onChange={(event) => setDetails(event.target.value.slice(0, 500))}
              rows={3}
              maxLength={500}
              placeholder="Contexto útil para a equipe analisar"
              disabled={submitting}
            />
            <small>{details.length}/500</small>
          </label>

          {error && <p className="report-modal-error" role="alert">{error}</p>}

          <div className="report-modal-actions">
            <button type="button" className="social-btn social-btn-ghost" disabled={submitting} onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="social-btn" disabled={submitting}>
              {submitting ? <FaSpinner className="social-spin" /> : <FaFlag />}
              Enviar denúncia
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
